import { ScrollReveal, FloatingImage } from '@/components/Animations';

const CAROLINE_IMG = 'https://static.wixstatic.com/media/bf3085_8c3cc1f03e5d4e2588d5e33e15a87b37~mv2.png/v1/crop/x_350,y_0,w_725,h_1024/fill/w_500,h_700,al_c,q_85/9ec865e1491d8062b2960825a8aeff16111b4ec90fdb799a2c5b951d949cbe04(1).png';

export default function About() {
  return (
    <div data-testid="about-page">
      <section className="py-20 sm:py-32 px-4" data-testid="about-hero">
        <div className="max-w-6xl mx-auto">
          <ScrollReveal>
            <p className="text-xs uppercase tracking-[0.3em] mb-4 font-semibold" style={{ fontFamily: 'Outfit, sans-serif', color: 'var(--color-primary)' }}>
              Notre histoire
            </p>
            <h1 className="text-4xl sm:text-5xl lg:text-6xl font-light mb-6" style={{ fontFamily: 'Cormorant Garamond, serif' }}>
              Qui est l'entrepreneure derrière Concept Gourmet ?
            </h1>
          </ScrollReveal>
        </div>
      </section>

      <section className="pb-20 sm:pb-32 px-4">
        <div className="max-w-6xl mx-auto grid grid-cols-1 lg:grid-cols-12 gap-12 lg:gap-16 items-start">
          <div className="lg:col-span-4">
            <ScrollReveal>
              <FloatingImage src={CAROLINE_IMG} alt="Caroline Bélanger"
                className="w-full max-w-sm mx-auto lg:mx-0 rounded-2xl overflow-hidden shadow-2xl" duration={7} />
            </ScrollReveal>
          </div>

          <div className="lg:col-span-8 space-y-6">
            <ScrollReveal delay={0.1}>
              <p className="text-lg leading-relaxed" style={{ fontFamily: 'Outfit, sans-serif' }}>
                Depuis mon enfance, l'alimentation fait partie de mon quotidien d'une façon distinctive et elle occupe une très grande importance pour moi. Mon intérêt pour la cuisine s'est développé au fur et à mesure que les années ont passées. Quand j'étais toute petite, je possédais un kiosque de fruits et légumes locaux. Je faisais la rencontre de producteurs et j'avais le souci d'offrir des aliments frais et diversifiés aux passants. J'avais déjà à cet âge un penchant vers l'entrepreneuriat.
              </p>
            </ScrollReveal>

            <ScrollReveal delay={0.2}>
              <h3 className="text-2xl font-light italic" style={{ fontFamily: 'Cormorant Garamond, serif', color: 'var(--color-primary)' }}>
                Une passion s'est installée !
              </h3>
            </ScrollReveal>

            <ScrollReveal delay={0.25}>
              <p className="text-lg leading-relaxed" style={{ fontFamily: 'Outfit, sans-serif' }}>
                Par la suite, j'ai poursuivi mes études en obtenant mon diplôme collégial en gestion de restauration. J'ai peaufiné mon côté entrepreneurial à l'université et j'ai obtenu des outils et des connaissances approfondies pour m'aider à me partir en affaires sur les bonnes bases. J'ai travaillé avec des chefs qui m'ont fait voir et expérimenter divers enjeux de la restauration et ainsi créer de belles inspirations. C'est ce qui m'a convaincu de faire de ma passion mon travail afin de la partager à ma clientèle.
              </p>
            </ScrollReveal>

            <ScrollReveal delay={0.3}>
              <p className="text-lg leading-relaxed" style={{ fontFamily: 'Outfit, sans-serif' }}>
                Je possède également un certificat en nutrition qui m'a permis d'acquérir des connaissances plus spécifiques pour aider les besoins nutritifs des clients. De l'enfant à la femme enceinte jusqu'aux personnes âgées, peu importe l'étape de la vie.
              </p>
            </ScrollReveal>

            <ScrollReveal delay={0.35}>
              <p className="text-lg leading-relaxed" style={{ fontFamily: 'Outfit, sans-serif' }}>
                J'adore cuisiner et voir le bonheur des gens déguster ! Participer à un projet et remarquer l'impact que cela peut apporter dans le quotidien des gens. En créant mon entreprise, j'ai adapté ma vie et ainsi offert à ma clientèle de belles expériences !
              </p>
            </ScrollReveal>

            <ScrollReveal delay={0.4}>
              <p className="text-lg leading-relaxed" style={{ fontFamily: 'Outfit, sans-serif' }}>
                Ce métier ne cesse de me faire découvrir de belles envies culinaires, et ce, chaque jour. La restauration est un beau domaine parce qu'elle évolue constamment et c'est ce qui me permet de vivre de magnifiques aventures enrichissantes !
              </p>
            </ScrollReveal>

            <ScrollReveal delay={0.45}>
              <p className="text-lg leading-relaxed" style={{ fontFamily: 'Outfit, sans-serif' }}>
                Au plaisir de vous rencontrer !
              </p>
              <p className="text-xl italic mt-4" style={{ fontFamily: 'Cormorant Garamond, serif', color: 'var(--color-primary)' }}>
                -Caroline Bélanger-
              </p>
              <p className="text-base font-semibold mt-1" style={{ color: 'var(--color-muted-fg)' }}>
                Chef | Propriétaire
              </p>
            </ScrollReveal>
          </div>
        </div>
      </section>
    </div>
  );
}
